import * as React from 'react'
import {Link} from 'react-router-dom'
import {isRemoveItemsActive} from '../../feature-flags'
import SolvvyButton, {SOLVVY_ADD_REMOVE_ITEM} from '../_shared/SolvvyButton'
import * as track from '../../track/track'

import {toPath} from '../../utils'
import {REMOVE_ITEMS_PAGE} from '../../urls'

interface Props {
  isParticipantUser: boolean
  openModal: () => void
  eventId: number
  orderId: number
}

const REMOVE_ITEM_LABEL = 'Remove Item'

export const RemoveItemsNavButton: React.FC<Props> = ({
  isParticipantUser,
  eventId,
  orderId,
  openModal,
}) => {
  if (isRemoveItemsActive) {
    if (isParticipantUser) {
      return <button onClick={openModal}>{REMOVE_ITEM_LABEL}</button>
    }

    return (
      <Link
        to={toPath(REMOVE_ITEMS_PAGE, {eventId, orderId})}
        onClick={track.clickedRemoveItemsButton}
      >
        {REMOVE_ITEM_LABEL}
      </Link>
    )
  }

  return <SolvvyButton workflowId={SOLVVY_ADD_REMOVE_ITEM}>{REMOVE_ITEM_LABEL}</SolvvyButton>
}
